// extracted by mini-css-extract-plugin
export default {"config":"QuickTimerConfig_config__NzDjN","configOption":"QuickTimerConfig_configOption__Iey8I","configOptionActive":"QuickTimerConfig_configOptionActive__zdb8g"};